import Toastify from 'https://esm.sh/toastify-js@1.12.0'
import { CartHandler, FavariteHandler, DataHander } from '//shop.pigeon.co.jp/cdn/shop/t/149/assets/bousai_20231225_lib.js?v=40603307227055383481749430708'


class App {
    constructor() {
        const self = this
        self.cartHandler = new CartHandler()
        self.favariteHandler = null
        self.dataHander = new DataHander()
        self.itemList = []
    }
    /**
     * 下記のタグより商品情報を取得するための関数
     * script[type="list-item-json"]
     * @returns {App}
     */
    getItemsJsonFromScriptTag() {
        const self = this
        const itemListJson = document.querySelectorAll('script[type="list-item-json"]')
        for (let elm of itemListJson) {
            let tmp = {}
            try {
                tmp = JSON.parse(elm.innerHTML)
                self.itemList.push(tmp)
            } catch (err) {
                console.error(err)
            }
        }
        self.dataHander.setData(self.itemList)
        return self
    }
    /**
     * カートボタンのイベント準備
     * @returns {App}
     */
    prepareCartBtn() {
        const self = this
        const cartBtns = document.querySelectorAll('button.item_cart')
        for (let cartBtn of cartBtns) {
            cartBtn.addEventListener('click', async (ev) => {
                const elm = ev.currentTarget
                const buttonHtmlBk = elm.innerHTML
                const cartCaution = elm.parentElement.querySelector('.cart_caution')
                const cartCautionMessage = cartCaution.querySelector('p')
                cartCaution.style.display = 'none'
                elm.disabled = true
                elm.classList.remove('item_cart')
                elm.classList.add('item_cart_none')
                elm.innerHTML = `<div class="circle"></div>`
                try {
                    const pid = elm.dataset.pid
                    const vid = elm.dataset.vid
                    const item = await self.dataHander.getItemByVid(vid)
                    console.log({ elm, pid, vid, item })
                    if (Object.keys(item).length > 0) {
                        let skuForsetItem = ''
                        if(item.is_set === true) {
                            skuForsetItem = item.first_variant_sku
                        }
                        const res = await self.cartHandler.smartAddShopifyCart(vid, item.item_buy_limit, item.product_id, skuForsetItem)
                        if (res.status === true) {
                            cartCaution.style.display = 'none'
                            // alert('商品をカートに追加しました。')
                            Toastify({
                                text: '商品をカートに追加しました。',
                                gravity: "top", // `top` or `bottom`
                                position: "center", // `left`, `center` or `right`
                                style: {
                                    background: '#333333',
                                    color: '#ffffff'
                                },
                            }).showToast()
                        } else {
                            cartCaution.style.display = ''
                            if (res.message) {
                                if (res.message) {
                                    if (res.message.errorMessage) {
                                        console.error(res.message.errorMessage)
                                        cartCautionMessage.innerHTML = res.message.errorMessage
                                    } else {
                                        console.error(res.message)
                                        cartCautionMessage.innerHTML = res.message
                                    }
                                }
                            } else {
                                cartCautionMessage.innerHTML = 'カートの追加に失敗しました。'
                            }
                        }
                        console.log(res)
                    } else {
                        // カートの追加に失敗
                        // 商品情報が存在しないため
                        cartCaution.style.display = ''
                        cartCautionMessage.innerHTML = 'カートの追加に失敗しました。'
                    }
                } catch (err) {
                    console.error(err)
                    cartCaution.style.display = 'none'
                    cartCautionMessage.innerHTML = 'カートの追加に失敗しました。'
                } finally {
                    elm.classList.remove('circle')
                    elm.innerHTML = buttonHtmlBk
                    elm.disabled = false
                    elm.classList.remove('item_cart_none')
                    elm.classList.add('item_cart')
                }

            })
        }
        return self
    }
    /**
     * お気に入りの初期値ロード
     * @param {NodeListOf<Element>} addWhishlistBtns 
     */
    async _loadWhishList(addWhishlistBtns, isReload = false) {
        const self = this
        if(isReload === true){
            await self.favariteHandler.getWishListItemsFromServer()
        }
        for (let addWhishlistBtn of addWhishlistBtns) {
            try {
                const elm = addWhishlistBtn
                const pid = elm.dataset.pid
                const vid = elm.dataset.vid
                // console.log({ elm, pid, vid })
                const rs = self.favariteHandler.isItemInList(pid)
                if (rs.status === true && rs.result === true) {
                    elm.classList.remove('fade_in')
                    elm.classList.remove('item_fav_off')
                    elm.classList.add('item_fav_on')
                    elm.classList.add('fade_in')
                } else {
                    elm.classList.remove('fade_in')
                    elm.classList.remove('item_fav_on')
                    elm.classList.add('item_fav_off')
                    elm.classList.add('fade_in')
                }
            } catch (err) {
                console.error(err)
            }
        }
    }
    /**
     * お気に入りボタンの初期状態＆イベントの準備
     * @returns {App}
     */
    prepareWhishListBtn() {
        const self = this
        document.addEventListener("wishlist-hero-wishlist-sdk-ready", async function (e) {
            self.favariteHandler = new FavariteHandler()
            const taskOfcreateWishListHash = self.favariteHandler.createWishListHash()
            const addWhishlistBtns = document.querySelectorAll('button.item_fav')
            await self._loadWhishList(addWhishlistBtns, false)
            for (let addWhishlistBtn of addWhishlistBtns) {
                addWhishlistBtn.addEventListener('click', async (ev) => {
                    try {
                        const elm = ev.currentTarget
                        const pid = elm.dataset.pid
                        const vid = elm.dataset.vid
                        if (elm.classList.contains('item_fav_on')) {
                            const rs = await self.favariteHandler.deleteItemFromWishListItem(vid)
                            if (rs.status && rs.status === true) {
                                elm.classList.remove('fade_in')
                                elm.classList.remove('item_fav_on')
                                elm.classList.add('item_fav_off')
                                elm.classList.add('fade_in')
                                Toastify({
                                    text: 'お気に入りリストから削除しました。',
                                    gravity: "top", // `top` or `bottom`
                                    position: "center", // `left`, `center` or `right`
                                    style: {
                                        background: '#333333',
                                        color: '#ffffff'
                                    },
                                }).showToast()
                            } else {
                                alert('お気に入りリストの削除に失敗しました。')
                            }
                        } else {
                            const item = await self.dataHander.getItemByVid(vid)
                            console.log({ elm, pid, vid, item })
                            if (Object.keys(item).length > 0) {
                                const rs = await self.favariteHandler.addWishListItem(pid, item.title, item.price, item.page_url, vid, item.img_url)
                                if (rs.status && rs.status === true) {
                                    elm.classList.remove('fade_in')
                                    elm.classList.remove('item_fav_off')
                                    elm.classList.add('item_fav_on')
                                    elm.classList.add('fade_in')
                                    Toastify({
                                        text: 'お気に入りリストに追加しました。',
                                        gravity: "top", // `top` or `bottom`
                                        position: "center", // `left`, `center` or `right`
                                        style: {
                                            background: '#333333',
                                            color: '#ffffff'
                                        },
                                    }).showToast()
                                } else {
                                    alert('お気に入りリストの追加に失敗しました。')
                                }
                            } else {
                                // お気に入りリストの追加に失敗
                                // 商品情報が存在しないため
                                console.log('商品情報が存在しないため、お気に入りリストの追加に失敗しました。')
                                alert('お気に入りリストの追加に失敗しました。')
                            }
                        }
                    } catch (err) {
                        console.error(err)
                    } finally {
                        await self._loadWhishList(addWhishlistBtns, true)
                    }
                })
            }
            taskOfcreateWishListHash.then(ev => {
                for (let addWhishlistBtn of addWhishlistBtns) {
                    addWhishlistBtn.style.display = ''
                }
                console.log('お気に入り機能の初期化完了')
            })
        })
        return self
    }
    /**
     * もっと見るボタンのイベントの準備
     * @returns {App}
     */
    prepareShowMoreItems() {
        const self = this
        const showMoreBtns = document.querySelectorAll('.goods_list button.more')
        for (let showMoreBtn of showMoreBtns) {
            showMoreBtn.addEventListener('click', (ev) => {
                const elm = ev.currentTarget
                const tabGroup = elm.dataset.tabGroup
                const listOfHidden = document.querySelectorAll(`#shopify-section-${tabGroup} li.list-hidden`)
                for (let elm of listOfHidden) {
                    elm.classList.remove('list-hidden')
                    elm.classList.add('fade_in')
                }
                // Android用に調整
                document.querySelector('html').style = 'scroll-behavior: auto;'
                elm.scrollIntoView({
                    behavior: "instant"
                })
                // Android用に調整
                document.querySelector('html').style = ''

                elm.classList.remove('unclicked')
            })
        }
        return self
    }
}

/**
 * エントリーポイント
 */
const main = async () => {
    new App()
        .getItemsJsonFromScriptTag()
        .prepareCartBtn()
        .prepareWhishListBtn()
        .prepareShowMoreItems()
}

await main()
